/**
 * Returns true if the environment is sets to production
 */
export const __prod__ = process.env.NODE_ENV === 'production'

export const __draft_post_enabled__ = process.env.ENABLE_DRAFT_POST === 'true'
